import * as React from "react";
import { withSitecoreContext, Link, RichText, Text } from "@sitecore-jss/sitecore-jss-react";
import { NavLink, useLocation } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { GenerateIdForGA } from "../../types/helpers";
import "./index.scss";
import { returnSvgImage } from "../../utils/svgImage";
import { scaleImage } from "../../utils/scaleImage";
import { checkDeviceType } from "../../utils/checkDeviceType";
import IvecoBusMobileMenu from "./ivecoBusMobileMenu";
import HeaderMenuModule from "../../react-only-components/HeaderMenuModule";
import { changeWishlistIconColor } from "./../../utils/WishlistApis";
import { useVehicleCardsScroll } from "../../hooks/VehicleCardsScrollContext";

const { useEffect, useRef, useState } = React;

type Dir = "up" | "down" | null;

export function useScrollDirection() {
  const { vcScroll } = useVehicleCardsScroll();
  const [dir, setDir] = useState<Dir>(null);
  const lastY = useRef(0);

  useEffect(() => {
    lastY.current = window.pageYOffset || 0;

    const onScroll = () => {
      if (vcScroll) return; 

      const y = window.pageYOffset || 0;
      const delta = y - lastY.current;
      if (Math.abs(delta) >= 16) {
        const next: Dir = delta > 0 ? "down" : "up";
        setDir((prev) => (prev !== next ? next : prev));
        lastY.current = y;
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [vcScroll]);

  return vcScroll ? ("down" as const) : dir;
}

const HeaderModule = (props) => {
  let currentNav = useLocation().pathname;
  const Dissolving = props?.fields?.Dissolving?.value;
  const { vcScroll } = useVehicleCardsScroll();
  const scrollRef = useRef(null);
  const [open, setOpen] = useState(false);
  const isRtl = props?.sitecoreContext?.ContextExtensions?.isRTL;
  const GlobalMenuLeft = props?.fields?.["Global Menu"]?.fields?.LeftNavigationList?.fields?.Links ?? [];
  const GlobalMenuRight = props?.fields?.["Global Menu"]?.fields?.RightNavigationList?.fields?.Links ?? [];
  const HideHeader = props?.fields?.["HideHeader"]?.value === true;;

  const FontSizeOfLinksInPx = props?.fields?.FontSizeOfLinksInPx?.value ? props?.fields?.FontSizeOfLinksInPx?.value : null;

  const enablePrivateArea = props?.fields?.["Global Menu"]?.fields?.UsePersonalisedButtons?.value;
  const isUserAuthenticated = props?.fields?.["Global Menu"]?.UserAuthenticated;
  const GlobalMenuLogin = props?.fields?.["Global Menu"]?.fields?.RightAnonButtons;
  const GlobalMenuUsersButtons = props?.fields?.["Global Menu"]?.fields?.RightUserButtons?.fields?.Links ?? [];

  const [selectedRightUserButton, setSelectedRightUserButton] = useState(null);

  const headerNavItems = props?.fields?.["Menu Links"]?.fields?.Links ?? [],
    navItems = useRef(null),
    themeOption = props?.params?.Theme;

  const showBurgerMenu = headerNavItems?.length > 0 || GlobalMenuLeft?.length > 0 || GlobalMenuRight?.length > 0;

  const [innerInternalWidth, setInnerInternalWidth] = useState(0);
  useEffect(() => {
    if (typeof document !== "undefined") {
      document.querySelectorAll(".global-menu-links__mobile .link").forEach((element) => {
        element.addEventListener("click", () => {
          element.querySelector(".link-toggle").classList.toggle("active");
        });
      });
    }
    if (typeof document !== "undefined") {
      const navItems = document.querySelectorAll("#header-li-element");
      navItems.forEach((element) => {
        element.classList.remove("link-with-content");
      });
    }
    if (typeof window != "undefined") {
      setInnerInternalWidth(window.innerWidth);
      window.addEventListener("resize", () => {
        setInnerInternalWidth(window.innerWidth);
      });
    }
  }, []);

  const onBurgerClick = (event) => {
    const target = event.currentTarget,
      navItemsWrapper = target.nextSibling;
    target.classList.toggle("open");
    target.parentElement.classList.toggle("dark-menu");
    // target.parentElement.parentElement.classList.toggle("dark-menu");
    navItemsWrapper.classList.toggle("opened");
    document.body.classList.toggle("overflow-hidden");
    setOpen(!open);

    if (selectedRightUserButton !== null) {
      setSelectedRightUserButton(null);
    }
  };

  const scrollDirection = useScrollDirection();


useEffect(() => {
  if (typeof document === "undefined") return;

  const headerEl = (scrollRef.current as any)?.closest?.("header") || (document.querySelector(".navbar-container") as HTMLElement | null);
  if (!headerEl) return;

  headerEl.classList.add("navbar-container");
  if (Dissolving === true) headerEl.classList.add("container");

  const baseTransition = "all" + " 0.5s " + "ease";

  const applyState = (want: "show" | "hide") => {
    // headerEl.style.transition = "none";
    headerEl.style.visibility = "hidden";

    headerEl.classList.toggle("show", want === "show");
    headerEl.classList.toggle("hide", want === "hide");

    void headerEl.offsetHeight;
    requestAnimationFrame(() => {
      // headerEl.style.transition = baseTransition;
      headerEl.style.visibility = "";
    });
  };

  const rafId = requestAnimationFrame(() => {
    if (Dissolving !== true) return;

    if (vcScroll) {
      applyState("hide");
      return;
    }
    if (scrollDirection === "down") applyState("hide");
    else if (scrollDirection === "up") applyState("show");
  });

  const onScroll = () => {
    const heroH = (scrollRef.current as any)?.clientHeight || 0;
    if (window.pageYOffset < heroH && headerEl.clientHeight) {
      document.querySelector(".header-bar-container")?.classList.remove("show");
      headerEl.classList.remove("show");
    }
  };
  window.addEventListener("scroll", onScroll, { passive: true });

  return () => {
    cancelAnimationFrame(rafId);
    window.removeEventListener("scroll", onScroll);
  };
}, [scrollDirection, vcScroll, Dissolving]);


  const [deviceType, setDeviceType] = useState("");
  const [windowWidth, setWindowWidth] = useState(null);
  const [active, setActive] = useState();
  const [hoveredItem, setHoveredItem] = useState(null);

  useEffect(() => {
    if (typeof window !== "undefined" && typeof navigator !== "undefined") {
      setDeviceType(checkDeviceType(navigator));
      setWindowWidth(window.innerWidth);
    }
    if (typeof window != "undefined") {
      setInnerInternalWidth(window.innerWidth);
      window.addEventListener("resize", () => {
        setInnerInternalWidth(window.innerWidth);
      });
    }
  }, []);

  const showLoaderNavigation = (isInternal) => {
    if (innerInternalWidth < 1136 && typeof document != "undefined" && document && document.getElementById("burgerMenuHeader")) {
      let target = document.getElementById("burgerMenuHeader");
      let navItemsWrapper: any = target.nextSibling;
      target.classList.toggle("open");
      target.parentElement.classList.toggle("dark-menu");
      target.parentElement.parentElement.classList.toggle("dark-menu");
      target.parentElement.parentElement.classList.toggle("dark-menu__full-width");
      navItemsWrapper.classList.toggle("opened");
      document.body.classList.toggle("overflow-hidden");
      document.getElementById("header-body-document").classList.add("header-loading");
    }
    if (isInternal && typeof document != "undefined" && document) {
      const el: any = document.getElementsByClassName("header-loader");
      if (el && el.length > 0) el[0].style.display = "block";
    }
  };

  const showOnlyLoaderNavigation = () => {
    if (typeof document != "undefined" && document) {
      document.getElementById("header-body-document").classList.add("header-loading");
      const el: any = document.getElementsByClassName("header-loader");
      if (el && el.length > 0) el[0].style.display = "block";
    }
  };

  const normalizeString = (str) => {
    return str.toLowerCase().replace(/\//g, "");
  };

  let foundActive = false;

  const openCloseMegaMenu = (key, item) => {
    if (typeof document != "undefined") {
      // if megaMenus open --> close all
      let megaMenus = document.getElementsByClassName("mega-menu-header active");
      if (megaMenus.length > 0) {
        setActive(null);
        for (let index = 0; index < megaMenus.length; index++) {
          if (megaMenus[index].id !== "mega-menu-header" + key) {
            megaMenus[index].classList.remove("active");
          }
        }
      }
    }

    // open or close and set active only the right one
    if (document.getElementById("mega-menu-header" + key).classList.contains("active")) {
      document.getElementById("mega-menu-header" + key).classList.remove("active");
    } else {
      setActive(item);
      document.getElementById("mega-menu-header" + key).classList.add("active");
    }
  };

  const getActiveClass = (index, className) => (active === index ? className : "");

  const isCurrentNavigation = (item, className) => {
    let yes = false;

    if (typeof window !== "undefined" && window && foundActive === false) {
      let url = (window.location.pathname + window.location.search).trim().toLowerCase();

      // console.log(foundActive,className, item?.fields?.Link?.value?.href.trim().toLowerCase() == url, item?.fields?.Link?.value?.href.trim().toLowerCase(),url, item);

      if (item?.fields?.Button?.value?.href.trim().toLowerCase() == url) {
        // console.log('FOUND:',item);
        yes = true;
        foundActive = item;
        return className;
      } else if (item?.fields?.Link?.value?.href.trim().toLowerCase() == url) {
        // console.log('FOUND ',item);
        yes = true;
        foundActive = item;
        return className;
      } else {
        item?.fields?.SubNavigationLinks?.fields?.Links.forEach((element) => {
          if (!yes && element?.fields?.Link?.value?.href.trim().toLowerCase() == url) {
            yes = true;
          }
        });
        if (!yes) {
          // console.log('not found: '+item);
          return "";
        } else {
          // console.log('found: '+item);
          foundActive = item;
          return className;
        }
      }
    } else if (foundActive === item) {
      return className;
    } else {
      return "";
    }
  };

  const arrow = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 12H21" stroke="#14181F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 7L21 12L16 17" stroke="#14181F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  const handleMouseEnter = (item) => {
    setHoveredItem(item);
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
  };

  useEffect(() => {
    /**
     * If the private area is enabled and the user is authenticated,
     * then check if the current page is on the wishlist in order to change the wishlist tab icon color
     */
    if (enablePrivateArea && isUserAuthenticated) {
      const wishlistTab = GlobalMenuUsersButtons.find((item) => item?.DB_items?.length >= 0);
      const isCurrPageOnWishlist = wishlistTab?.DB_items?.some(
        (item) => item?.fields?.PageId?.value === wishlistTab?.Wishlist_Button?.PageId
      );

      changeWishlistIconColor(isCurrPageOnWishlist);
    }
  }, [enablePrivateArea, isUserAuthenticated]);

  return (
    <>
      <section
        className={
          `header-bar-container  ${
            (scrollDirection === "down" || scrollDirection === "up" || scrollDirection === null) && Dissolving === true ? "" : "show"
          } ` + themeOption
        }
        style={HideHeader && innerInternalWidth > 1136 ? { display: "none" } : {}}
        ref={scrollRef}
      >
        <div
          className={`header-bar ${isRtl ? "header-rtl" : ""} cp-row`}
          style={{
            flexDirection: !showBurgerMenu && innerInternalWidth < 1136 ? "row-reverse" : null,
          }}
        >
          {showBurgerMenu ? (
            <span className="burger-menu device-menu" id="burgerMenuHeader" onClick={(event) => onBurgerClick(event)}>
              <div>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </span>
          ) : null}
          <div
            className={`nav-items ${GlobalMenuLeft !== "" ? "service-menu" : ""}`}
            ref={navItems}
            style={enablePrivateArea && innerInternalWidth < 1136 ? { paddingTop: "84px" } : {}}
          >
            {enablePrivateArea && isUserAuthenticated && innerInternalWidth < 1136 ? (
              <ul className="header-menu-tabs">
                <li
                  className={`header-menu-tab ${selectedRightUserButton === null ? "active" : ""}`}
                  onClick={() => setSelectedRightUserButton(null)}
                >
                  <span className="burger-menu device-menu">
                    <div>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </span>
                </li>
                {GlobalMenuUsersButtons.map((item, i) => (
                  <li
                    key={i}
                    className={
                      `header-menu-tab ${selectedRightUserButton === item ? "active" : ""}` +
                      `${item?.Wishlist_Button ? " wishlist-tab-icon" : ""}`
                    }
                    onClick={() => setSelectedRightUserButton(item)}
                  >
                    <span
                      className="icon"
                      dangerouslySetInnerHTML={{
                        __html: item?.fields?.Iconcss?.value
                          ? returnSvgImage(item?.fields?.Icon?.value, item?.fields?.Iconcss?.value)
                          : item?.fields?.Icon?.value?.svgCode,
                      }}
                    />
                  </li>
                ))}
              </ul>
            ) : null}

            <div className="m-links-container">
              <ul className="m-links-ul" style={enablePrivateArea && selectedRightUserButton !== null ? { display: "none" } : {}}>
                {headerNavItems?.map((item, i) => {
                  return (
                    <li
                      key={i}
                      className={`class ${item?.fields?.Icon ? "liWithIconMenuBar" : ""} ${
                        i > 0 && headerNavItems[i - 1].fields?.Icon && !item?.fields?.Icon ? "afterliWithIconMenuBar" : ""
                      }`}
                    >
                      {item?.fields?.Sublinks ? (
                        <IvecoBusMobileMenu
                          sublinks={item?.fields?.Sublinks}
                          themeOption={themeOption}
                          mainTitle={item?.fields?.["Main Title"]?.value}
                        />
                      ) : (
                        ""
                      )}

                      {item?.fields?.Sublinks ? (
                        <div
                          className={`link-with-content ${getActiveClass(item, "active")} `}
                          key={item?.id}
                          onClick={() => openCloseMegaMenu(i, item)}
                        >
                          <span className="link-title">{item?.fields?.["Main Title"]?.value}</span>
                          <div className={`mega-menu-header ${themeOption}`} id={"mega-menu-header" + i} key={i}>
                            <div className="menu">
                              <div className="large-resize cp-row">
                                <div className="title col-3">
                                  <Text tag="h5" field={item?.fields?.["Main Title"]}></Text>
                                  {item?.fields?.Button?.value?.href && (
                                    <Link
                                      field={item?.fields?.Button}
                                      className="main-button"
                                      id={GenerateIdForGA("globalMenu", item?.fields?.Button?.text + "_mainButton")}
                                    >
                                      <span className="text">{item?.fields?.Button?.value?.text}</span>
                                      <span className="menu-arrow">{arrow}</span>
                                    </Link>
                                  )}
                                </div>
                                <div className="links-container cp-row col-6" onMouseLeave={handleMouseLeave}>
                                  <div className={`links col-6 left-links`}>
                                    {item?.fields?.Sublinks?.map((el, x) => (
                                      <Link
                                        className="links-link"
                                        field={el?.fields?.Link}
                                        key={x}
                                        id={GenerateIdForGA("globalMenu", el?.fields?.Link?.value?.text + "_subNavigation")}
                                        onMouseEnter={() => handleMouseEnter(el)}
                                      >
                                        <span className="links-content">
                                          <span className="link-text">{el?.fields?.["Main Title"]?.value}</span>
                                          <span className="menu-arrow">{arrow}</span>
                                        </span>
                                      </Link>
                                    ))}
                                  </div>
                                  <div className={`links col-6 right-links`}>
                                    {hoveredItem &&
                                      hoveredItem?.fields?.Sublinks?.map(
                                        (el) => {
                                          return (
                                            <Link className="links-link" field={el?.fields?.Link} key={el?.fields?.id}>
                                              <span className="links-content">
                                                <span className="link-text">{el?.fields?.["Main Title"]?.value}</span>
                                              </span>
                                            </Link>
                                          );
                                        }
                                        /* <span
                                        className="links-link"
                                        key={el?.fields?.id}
                                        id={GenerateIdForGA(
                                          "globalMenu",
                                          el?.fields?.Link?.value?.text + "_subNavigation"
                                        )}
                                      >
                                        <span className="links-content">
                                          <span className="link-text">
                                            {el?.fields?.["Main Title"]?.value}
                                          </span>
                                        </span>
                                      </span> */
                                      )}
                                  </div>
                                </div>
                                {item?.fields?.Image?.value?.src !== undefined && (
                                  <div className="highlight col-3">
                                    <LazyLoadImage
                                      src={hoveredItem ? hoveredItem?.fields?.Image?.value?.src : item?.fields?.["Image"]?.value?.src}
                                      alt={hoveredItem ? hoveredItem?.fields?.Image?.value?.alt : item?.fields?.["Image"]?.value?.src}
                                      height={
                                        hoveredItem ? hoveredItem?.fields?.Image?.value?.height : item?.fields?.["Image"]?.value?.height
                                      }
                                      width={hoveredItem ? hoveredItem?.fields?.Image?.value?.width : item?.fields?.["Image"]?.value?.width}
                                    ></LazyLoadImage>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : false ? (
                        <NavLink
                          onClick={() => showLoaderNavigation(item?.fields?.Link?.value?.linktype !== "external")}
                          exact
                          className={item?.fields?.Link?.value?.class}
                          isActive={() => true}
                          activeClassName="active"
                          to={item?.fields?.Link?.value?.href}
                          id={GenerateIdForGA("header", item?.fields?.Link?.value?.text)}
                          style={{
                            fontSize: FontSizeOfLinksInPx ? FontSizeOfLinksInPx + "px" : null,
                          }}
                        >
                          {item?.fields?.Link?.value?.class == "thirdcharactercolored" ? (
                            <>
                              {item?.fields?.Link?.value?.text.substring(0, 2)}
                              <span className="thirdchar">{item?.fields?.Link?.value?.text[2]}</span>
                              {item?.fields?.Link?.value?.text.substring(4, item?.fields?.Link?.value?.text.length - 1)}
                            </>
                          ) : (
                            item?.fields?.Link?.value?.text
                          )}
                        </NavLink>
                      ) : (
                        <Link
                          onClick={() => showLoaderNavigation(item?.fields?.Link?.value?.linktype !== "external")}
                          className={
                            // check if Background.value is set and true
                            (item?.fields?.Background?.value ? "backgroundHeaderLink " : item?.fields?.Link?.value?.class || "") +
                            " " +
                            //only for DealerPortal we check if the link contains only the virtual folder
                            (props?.fields?.Activeonsubpages?.value && item?.fields?.Link?.value?.href.split("/").length > 2
                              ? normalizeString(currentNav).includes(normalizeString(item?.fields?.Link?.value?.href))
                                ? " active"
                                : ""
                              : normalizeString(item?.fields?.Link?.value?.href) == normalizeString(currentNav)
                              ? " active"
                              : "")
                          }
                          field={item?.fields?.Link}
                          aria-label="_"
                          id={GenerateIdForGA("header", item?.fields?.Link?.value?.text)}
                          style={{
                            fontSize: FontSizeOfLinksInPx ? FontSizeOfLinksInPx + "px" : null,
                          }}
                        >
                          {item?.fields?.Icon?.value.src && (
                            <img
                              className="icon"
                              src={item?.fields?.Icon?.value.src}
                              alt={item?.fields?.Icon?.value.alt}
                              width={item?.fields?.Icon?.value.width}
                              height={item?.fields?.Icon?.value.height}
                            />
                          )}

                          {item?.fields?.Link?.value?.class == "thirdcharactercolored" ? (
                            <>
                              {item?.fields?.Link?.value?.text.substring(0, 2)}
                              <span className="thirdchar">{item?.fields?.Link?.value?.text[2]}</span>
                              {item?.fields?.Link?.value?.text.substring(3, item?.fields?.Link?.value?.text.length)}
                            </>
                          ) : (
                            item?.fields?.Link?.value?.text
                          )}
                        </Link>
                      )}
                    </li>
                  );
                })}
              </ul>
              {props?.fields?.["Global Menu"] ? (
                <div
                  className="global-menu-links__mobile"
                  style={enablePrivateArea && selectedRightUserButton !== null ? { display: "none" } : {}}
                >
                  <div className="left">
                    <ul>
                      {enablePrivateArea ? (
                        isUserAuthenticated ? (
                          <></>
                        ) : (
                          <li className="link-login">
                            <form
                              action={GlobalMenuLogin?.LoginUrl}
                              method="POST"
                              className="global-menu-login-form global-menu-login-form__mobile"
                            >
                              <button className="login-btn" type="submit">
                                <span
                                  className="icon"
                                  dangerouslySetInnerHTML={{
                                    __html: GlobalMenuLogin?.fields?.Icon?.value?.svgCode,
                                  }}
                                />
                                {GlobalMenuLogin?.fields?.Label?.value}
                              </button>
                            </form>
                          </li>
                        )
                      ) : null}
                      {GlobalMenuLeft?.map((item, i) =>
                        item?.fields?.Description ? (
                          <li key={i} className="link">
                            <p className="link-toggle">
                              <span>{item?.fields?.Link?.value?.text}</span>
                              <span
                                className="icon"
                                dangerouslySetInnerHTML={{
                                  __html: item?.fields?.Iconcss?.value
                                    ? returnSvgImage(item?.fields?.Icon?.value, item?.fields?.Iconcss?.value)
                                    : item?.fields?.Icon?.value?.svgCode,
                                }}
                              />
                            </p>
                            <div className="links-content">
                              <ul>
                                {item?.fields?.SubNavigationLinks?.fields?.Links?.map((el, x) => (
                                  <li>
                                    {false ? (
                                      <NavLink
                                        onClick={() => showLoaderNavigation(el?.fields?.Link?.value?.linktype !== "external")}
                                        exact
                                        className="links-link"
                                        key={x}
                                        to={el?.fields?.Link?.value?.href}
                                        id={GenerateIdForGA("header", el?.fields?.Link?.value?.text)}
                                      >
                                        <span
                                          className="link-icon"
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              innerInternalWidth < 1136 && el?.fields?.["Mobile Icon"]?.value && el?.fields?.Iconcss?.value
                                                ? returnSvgImage(el?.fields?.["Mobile Icon"]?.value, el?.fields?.Iconcss?.value)
                                                : returnSvgImage(el?.fields?.Icon?.value, el?.fields?.Iconcss?.value),
                                          }}
                                        />
                                        <span>{el?.fields?.Link?.value?.text}</span>
                                      </NavLink>
                                    ) : (
                                      <Link
                                        onClick={() => showLoaderNavigation(el?.fields?.Link?.value?.linktype !== "external")}
                                        className="links-link"
                                        field={el?.fields?.Link}
                                        key={x}
                                        aria-label="_"
                                        id={GenerateIdForGA("header", el?.fields?.Link?.value?.text)}
                                      >
                                        <span
                                          className="link-icon"
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              innerInternalWidth < 1136 && el?.fields?.["Mobile Icon"]?.value
                                                ? returnSvgImage(el?.fields?.["Mobile Icon"]?.value, el?.fields?.Iconcss?.value)
                                                : returnSvgImage(el?.fields?.Icon?.value, el?.fields?.Iconcss?.value),
                                          }}
                                        />
                                        <span>{el?.fields?.Link?.value?.text}</span>
                                      </Link>
                                    )}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </li>
                        ) : (
                          <li key={i}>
                            {false ? (
                              <NavLink
                                onClick={() => showLoaderNavigation(item?.fields?.Link?.value?.linktype !== "external")}
                                exact
                                className={`link-simple ${item?.fields?.IsHighlighted?.value ? "link-highlighted" : ""}`}
                                to={item?.fields?.Link?.value?.href}
                                id={GenerateIdForGA("header", item?.fields?.Link?.value?.text)}
                              >
                                <span
                                  className="icon"
                                  dangerouslySetInnerHTML={{
                                    __html: item?.fields?.Iconcss?.value
                                      ? returnSvgImage(item?.fields?.Icon?.value, item?.fields?.Iconcss?.value)
                                      : item?.fields?.Icon?.value?.svgCode,
                                  }}
                                />
                                {item?.fields?.Link?.value?.text}
                                {item?.fields?.Link?.value?.linktype === "external" && item?.fields?.Icon?.value?.svgCode === "" ? (
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className={isRtl ? "icon-rtl" : ""}
                                  >
                                    <path
                                      d="M6 9L12 3"
                                      stroke="#9E9E9E"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M7 3H12V8"
                                      stroke="#9E9E9E"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                ) : (
                                  ""
                                )}
                              </NavLink>
                            ) : (
                              <Link
                                onClick={() => showLoaderNavigation(item?.fields?.Link?.value?.linktype !== "external")}
                                className={`link-simple ${item?.fields?.IsHighlighted?.value ? "link-highlighted" : ""}`}
                                field={item?.fields?.Link}
                                aria-label="_"
                                id={GenerateIdForGA("header", item?.fields?.Link?.value?.text)}
                              >
                                <span
                                  className="icon"
                                  dangerouslySetInnerHTML={{
                                    __html: item?.fields?.Iconcss?.value
                                      ? returnSvgImage(item?.fields?.Icon?.value, item?.fields?.Iconcss?.value)
                                      : item?.fields?.Icon?.value?.svgCode,
                                  }}
                                />
                                {item?.fields?.Link?.value?.text}
                                {item?.fields?.Link?.value?.linktype === "external" &&
                                (!item?.fields?.Icon || !item?.fields?.Icon?.value || item?.fields?.Icon?.value?.svgCode === "") ? (
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className={isRtl ? "icon-rtl" : ""}
                                  >
                                    <path
                                      d="M6 9L12 3"
                                      stroke="#9E9E9E"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M7 3H12V8"
                                      stroke="#9E9E9E"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                ) : (
                                  ""
                                )}
                              </Link>
                            )}
                          </li>
                        )
                      )}
                    </ul>
                  </div>
                  <div className="right">
                    <ul>
                      {GlobalMenuRight?.map((item, i) => (
                        <li key={i}>
                          {false ? (
                            <NavLink
                              onClick={() => showLoaderNavigation(item?.fields?.Link?.value?.linktype !== "external")}
                              exact
                              className={`link-simple ${item?.fields?.IsHighlighted?.value ? "link-highlighted" : ""} ${item?.fields?.ForceNotWhite?.value ? "link-blue-icon" : ""}`}
                              to={item?.fields?.Link?.value?.href}
                              id={GenerateIdForGA("header", item?.fields?.Link?.value?.text)}
                            >
                              <span
                                className="icon"
                                dangerouslySetInnerHTML={{
                                  __html: item?.fields?.Iconcss?.value
                                    ? returnSvgImage(item?.fields?.Icon?.value, item?.fields?.Iconcss?.value)
                                    : item?.fields?.Icon?.value?.svgCode,
                                }}
                              />
                              {item?.fields?.Link?.value?.text}
                              {item?.fields?.Link?.value?.linktype === "external" &&
                              (!item?.fields?.Icon || !item?.fields?.Icon?.value || item?.fields?.Icon?.value?.svgCode === "") ? (
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className={isRtl ? "icon-rtl" : ""}
                                >
                                  <path d="M6 9L12 3" stroke="#9E9E9E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M7 3H12V8" stroke="#9E9E9E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                              ) : (
                                ""
                              )}
                            </NavLink>
                          ) : (
                            <Link
                              onClick={() => showLoaderNavigation(item?.fields?.Link?.value?.linktype !== "external")}
                              className={`link-simple ${item?.fields?.IsHighlighted?.value ? "link-highlighted" : ""} ${item?.fields?.ForceNotWhite?.value ? "link-blue-icon" : ""}`}
                              field={item?.fields?.Link}
                              aria-label="_"
                              id={GenerateIdForGA("header", item?.fields?.Link?.value?.text)}
                            >
                              <span
                                className="icon"
                                dangerouslySetInnerHTML={{
                                  __html: item?.fields?.Iconcss?.value
                                    ? returnSvgImage(item?.fields?.Icon?.value, item?.fields?.Iconcss?.value)
                                    : item?.fields?.Icon?.value?.svgCode,
                                }}
                              />
                              {item?.fields?.Link?.value?.text}
                              {item?.fields?.Link?.value?.linktype === "external" &&
                              (!item?.fields?.Icon || !item?.fields?.Icon?.value || item?.fields?.Icon?.value?.svgCode === "") ? (
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className={isRtl ? "icon-rtl" : ""}
                                >
                                  <path d="M6 9L12 3" stroke="#9E9E9E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M7 3H12V8" stroke="#9E9E9E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                              ) : (
                                ""
                              )}
                            </Link>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ) : (
                ""
              )}
              {isUserAuthenticated && enablePrivateArea && selectedRightUserButton && (
                <HeaderMenuModule
                  dropDownOption={innerInternalWidth > 1136}
                  selectedButton={selectedRightUserButton}
                  userFullName={props?.fields?.["Global Menu"]?.UserFullName}
                  userEmail={props?.fields?.["Global Menu"]?.UserEmail}
                />
              )}
            </div>
          </div>
          <div className="header-logo">
            {false ? (
              <NavLink
                onClick={() => showOnlyLoaderNavigation()}
                exact
                to={props?.fields?.["Logo Link"]?.value?.href}
                id={GenerateIdForGA("header", props?.fields?.["Logo Link"]?.value?.text)}
              >
                {open ? (
                  <LazyLoadImage
                    width="142"
                    height="30"
                    src={
                      props?.fields?.LogoDark?.value?.src != undefined
                        ? props?.fields?.LogoDark?.value?.src
                        : props?.fields?.Logo?.value?.src
                    }
                    alt={
                      props?.fields?.LogoDark?.value?.alt != undefined
                        ? props?.fields?.LogoDark?.value?.alt
                        : props?.fields?.Logo?.value?.alt
                    }
                    className="logo-img"
                  ></LazyLoadImage>
                ) : (
                  <LazyLoadImage
                    width="142"
                    height="30"
                    src={props?.fields?.Logo?.value?.src}
                    alt={props?.fields?.Logo?.value?.alt}
                    className="logo-img"
                  ></LazyLoadImage>
                )}
              </NavLink>
            ) : (
              <Link
                onClick={() => showOnlyLoaderNavigation()}
                field={props?.fields?.["Logo Link"]}
                aria-label="_"
                id={GenerateIdForGA("header", props?.fields?.["Logo Link"]?.value?.text)}
              >
                {open ? (
                  <LazyLoadImage
                    width="142"
                    height="30"
                    src={
                      props?.fields?.LogoDark?.value?.src != undefined
                        ? props?.fields?.LogoDark?.value?.src
                        : props?.fields?.Logo?.value?.src
                    }
                    alt={
                      props?.fields?.LogoDark?.value?.alt != undefined
                        ? props?.fields?.LogoDark?.value?.alt
                        : props?.fields?.Logo?.value?.alt
                    }
                    className="logo-img"
                  ></LazyLoadImage>
                ) : (
                  <LazyLoadImage
                    width="142"
                    height="30"
                    src={props?.fields?.Logo?.value?.src}
                    alt={props?.fields?.Logo?.value?.alt}
                    className="logo-img"
                  ></LazyLoadImage>
                )}
              </Link>
            )}
          </div>
        </div>
      </section>
      <div className="header-loader">
        <div className="loader-element"></div>
      </div>
    </>
  );
};

export default withSitecoreContext()(HeaderModule);
